import script from "./SurveySecondaryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveySecondaryComponent.vue?vue&type=script&setup=true&lang=js"

import "./SurveySecondaryComponent.vue?vue&type=style&index=0&id=f6e2c42e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6e2c42e"]])

export default __exports__